import React, { memo } from 'react';

interface TouchPadIconProps {
  width?: number;
  height?: number;
  className?: string;
  onClick?: () => void;
  /** Meta columns collapsed: default chevron direction. Expanded: rotated 180°. */
  collapsed?: boolean;
}

const TouchPadIcon: React.FC<TouchPadIconProps> = memo(
  ({ width = 12, height = 12, className, onClick, collapsed = true }) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 12 12"
        fill="none"
        className={className}
        onClick={onClick}
        data-expanded={!collapsed ? true : undefined}
      >
        <path
          d="M5.77091 9.74686C5.59161 9.57459 5.58575 9.28983 5.7586 9.11112L8.7504 6.00096L5.75099 2.8826C5.57814 2.70389 5.584 2.41913 5.7633 2.24686C5.94142 2.07459 6.22677 2.07987 6.39904 2.25917L9.69904 5.68925C9.8672 5.86327 9.8672 6.13866 9.69904 6.31268L6.40666 9.73455C6.31876 9.82654 6.20041 9.87284 6.08263 9.87284C5.97013 9.87284 5.85763 9.83123 5.77091 9.74686Z"
          fill="#292929"
        />
        <path
          d="M2.32071 9.74686C2.14142 9.57459 2.13555 9.28983 2.30841 9.11112L5.30021 6.00096L2.30079 2.8826C2.12795 2.70389 2.1338 2.41913 2.3131 2.24686C2.49122 2.07459 2.77658 2.07987 2.94884 2.25917L6.24884 5.68925C6.417 5.86327 6.417 6.13866 6.24884 6.31268L2.95646 9.73455C2.86857 9.82654 2.75021 9.87284 2.63244 9.87284C2.51993 9.87284 2.40743 9.83123 2.32071 9.74686Z"
          fill="#292929"
        />
      </svg>
    );
  }
);

TouchPadIcon.displayName = 'TouchPadIcon';

export default TouchPadIcon;
